import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div className="container mt-4">
      <div className="row">
        <div className="standardBackground col-md-12">
          <div className="row" style={{padding: '1rem', alignItems: 'center'}}>
            <div className="col-md-6 textAlignLeft">
              <strong>ANDELSBOLIGFORENINGEN VANLØSEGAARD</strong><br />
              Jernbane Allé 92, st. th.<br />
              2720 Vanløse
            </div>
            <div className="col-md-6" style={{textAlign: 'right'}}>
              <Link className="Navigation-link" to="/handelsbetingelser">Handelsbetingelser</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
